import React from 'react';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { SEO } from './components/SEO';
export function App() {
  return <div className="min-h-screen w-full font-sans" data-id="element-0">
      <SEO data-id="element-1" />
      <Navigation data-id="element-2" />
      <main className="w-full" data-id="element-3">
        <HomePage data-id="element-4" />
      </main>
      <Footer data-id="element-5" />
    </div>;
}